module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = ../../../../../src/scss/icons/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module chunks = styles